<div class="row align-items-stretch g-3">
  <div class="col-auto">
    <div class="custom-card">
      <div id="corrections-1" class="corrections-card p-4 rounded-4 clearfix">
        <h5>ลงทะเบียนแบบกลุ่ม</h5>
        <h4 class="fw-semibold text-truncate">สิทธิ UC ล่วงหน้า</h4>
        <h4 class="fw-semibold text-truncate">&nbsp;</h4>
        <button class="btn btn-custom card-button" routerLink="./registration" id="return-registration" type="button">
          เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="col-auto">
    <div class="custom-card">
      <div id="corrections-3" class="corrections-card p-4  rounded-4">
        <h5 class="text-nowrap">ค้นหาประวัติการลงทะเบียนแบบกลุ่ม</h5>
        <h4 class="fw-semibold text-truncate">สิทธิ UC ล่วงหน้า</h4>
        <h4 class="fw-semibold text-truncate">&nbsp;</h4>
        <button class="btn btn-custom card-button" type="button" routerLink="./history" id="return-history">
          เลือก <i class="bi bi-chevron-right fw-bold ms-2"></i>
        </button>
      </div>
    </div>
  </div>
</div>
